import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-8">
            ← Back to Home
          </Button>
        </Link>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-8">About Crucar</h1>
        
        <div className="space-y-8 text-gray-600">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
            <p className="text-lg">
              At Crucar, we are pioneers in the art of data alchemy for the Automotive aftermarket, transforming raw, unstructured information into a goldmine of actionable insights. Our mission goes beyond mere data analysis; we are committed to empowering businesses with comprehensive, cutting-edge data solutions that drive informed decision-making and catalyze sustainable growth.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">What We Do</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-medium text-gray-800 mb-2">Data Collection</h3>
                <p>Advanced web scraping and data aggregation from multiple sources, ensuring comprehensive market coverage.</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-medium text-gray-800 mb-2">Data Processing</h3>
                <p>Sophisticated cleaning, normalization, and enrichment processes to deliver high-quality, reliable data.</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-medium text-gray-800 mb-2">API Access</h3>
                <p>Real-time data access through our robust API, enabling seamless integration with your existing systems.</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-xl font-medium text-gray-800 mb-2">Analytics</h3>
                <p>Advanced analytics and visualization tools to help you extract meaningful insights from your data.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Choose Us</h2>
            <ul className="list-disc pl-6 space-y-3">
              <li>Comprehensive data coverage across multiple markets and segments</li>
              <li>Real-time updates and high data accuracy</li>
              <li>Scalable solutions that grow with your business</li>
              <li>Enriched, reviewed and accurate product and segment data</li>
              <li>Customizable data delivery formats</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
            <p className="text-lg">
              Ready to unlock the power of data? Contact our team to learn more about how Crucar can help your business thrive.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
